import { observer } from "mobx-react";
import React from "react";
import { IOrgConfig } from "../../../models/currentUser/OrgConfig";
import { IUserProfile } from "../../../models/currentUser/UserProfile";
import { NumericStepper } from "../../numericStepper/numericStepper";
import { DiscardApplyButtons } from "../discardApplyButtons";
import styles from "./autoAssignedLimitInput.css";

export interface Props {
  orgConfigOrProfile: IUserProfile | IOrgConfig;
}

export interface State {
  limit: number | undefined;
}

@observer
export class AutoAssignedLimitInput extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      limit: this.props.orgConfigOrProfile.autoAssignedLimit
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    const { autoAssignedLimit } = nextProps.orgConfigOrProfile!;
    if (autoAssignedLimit !== this.state.limit) {
      this.setState({ limit: autoAssignedLimit });
    }
  }

  handleChange = (limit: number | undefined) => {
    // type and range validation is ensured by NumericStepper
    this.setState({ limit });
  };

  canBeSubmitted = () => {
    const { autoAssignedLimit } = this.props.orgConfigOrProfile;
    return this.state.limit !== autoAssignedLimit && this.state.limit !== undefined;
  };

  handleSubmit = () => {
    if (this.state.limit !== undefined && this.canBeSubmitted()) {
      this.props.orgConfigOrProfile.setAutoAssignedLimit(this.state.limit);
    }
  };

  handleDiscard = () => {
    this.setState({ limit: this.props.orgConfigOrProfile.autoAssignedLimit });
  };

  render() {
    return (
      <form className={styles.container} onSubmit={(ev) => ev.preventDefault()}>
        <NumericStepper
          min={0}
          max={99}
          value={this.state.limit}
          onChange={this.handleChange}
          placeholder="6"
        />
        <DiscardApplyButtons
          onApply={this.handleSubmit}
          onDiscard={this.handleDiscard}
          hidden={!this.canBeSubmitted()}
        />
      </form>
    );
  }
}
